import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LangProvider } from "@/lib/i18n";
import { Loader } from "@/components/common";
import Login from "@/pages/Login";
import DriverHome from "@/pages/driver/DriverHome";
import MyTrips from "@/pages/driver/MyTrips";
import NewTrip from "@/pages/driver/NewTrip";
import MyNotifications from "@/pages/driver/MyNotifications";
import ViolationView from "@/pages/driver/ViolationView";
import MyDocuments from "@/pages/driver/MyDocuments";
import MyAccount from "@/pages/driver/MyAccount";
import TripView from "@/pages/TripView";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Drivers from "@/pages/admin/Drivers";
import DriverProfile from "@/pages/admin/DriverProfile";
import Vehicles from "@/pages/admin/Vehicles";
import Trips from "@/pages/admin/Trips";
import Invoices from "@/pages/admin/Invoices";
import InvoiceDetail from "@/pages/admin/InvoiceDetail";
import Violations from "@/pages/admin/Violations";
import Notifications from "@/pages/admin/Notifications";
import Documents from "@/pages/admin/Documents";
import MonthlyDocsReport from "@/pages/admin/MonthlyDocsReport";
import Fees from "@/pages/admin/Fees";
import FeeStatement from "@/pages/admin/FeeStatement";
import Audit from "@/pages/admin/Audit";
import Salaries from "@/pages/admin/Salaries";
import Reports from "@/pages/admin/Reports";
import Settings from "@/pages/admin/Settings";
import DriverShell from "@/pages/driver/DriverShell";
import Splash from "@/components/Splash";

function Guard({ driver }) {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (driver && user.role !== "driver") return <Navigate to="/admin" replace />;
  if (!driver && user.role === "driver") return <Navigate to="/driver" replace />;
  return <Outlet />;
}

function Home() {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "driver" ? "/driver" : "/admin"} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route element={<Guard driver />}>
            <Route element={<DriverShell />}>
              <Route path="/driver" element={<DriverHome />} />
              <Route path="/driver/trips" element={<MyTrips />} />
              <Route path="/driver/trips/new" element={<NewTrip />} />
              <Route path="/driver/trips/:id" element={<TripView />} />
              <Route path="/driver/notifications" element={<MyNotifications />} />
              <Route path="/driver/violations/:id" element={<ViolationView />} />
              <Route path="/driver/documents" element={<MyDocuments />} />
              <Route path="/driver/account" element={<MyAccount />} />
            </Route>
          </Route>
          <Route element={<Guard />}>
            <Route element={<AdminLayout />}>
              <Route path="/admin" element={<Dashboard />} />
              <Route path="/admin/drivers" element={<Drivers />} />
              <Route path="/admin/drivers/:id" element={<DriverProfile />} />
              <Route path="/admin/vehicles" element={<Vehicles />} />
              <Route path="/admin/trips" element={<Trips />} />
              <Route path="/admin/trips/:id" element={<TripView admin />} />
              <Route path="/admin/invoices" element={<Invoices />} />
              <Route path="/admin/invoices/:id" element={<InvoiceDetail />} />
              <Route path="/admin/violations" element={<Violations />} />
              <Route path="/admin/notifications" element={<Notifications />} />
              <Route path="/admin/documents" element={<Documents />} />
              <Route path="/admin/documents/monthly" element={<MonthlyDocsReport />} />
              <Route path="/admin/fees" element={<Fees />} />
              <Route path="/admin/fees/:driverId" element={<FeeStatement />} />
              <Route path="/admin/audit" element={<Audit />} />
              <Route path="/admin/salaries" element={<Salaries />} />
              <Route path="/admin/reports" element={<Reports />} />
              <Route path="/admin/settings" element={<Settings />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors dir="rtl" toastOptions={{ style: { fontFamily: "Almarai", fontSize: 17 } }} />
      <Splash />
      </LangProvider>
    </AuthProvider>
  );
}
